import { css } from "@/domains/emotion";
import { MDSText, MDSTextVariant, MDSTextWeight, MDSButton } from "@/mds";
import { windowModule } from "@/modules/window";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC, useCallback, useMemo } from "react";

const wrapperStyles = css({
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  WebkitAppRegion: "no-drag",
});

const StyledHeaderText = styled(MDSText)`
  margin-bottom: 20px;
`;

const StyledErrorMessageText = styled(MDSText)`
  margin-bottom: 20px;
`;

interface ErrorBoxProps {
  message?: string;
}

export const ErrorBox: FC<ErrorBoxProps> = observer(({ message }) => {
  const forceRefreshPage = useCallback(() => {
    windowModule.forceHardReload();
  }, []);

  const messageContent = useMemo(() => {
    if (!message) {
      return null;
    }

    return (
      <StyledErrorMessageText variant={MDSTextVariant.TextS}>
        Message: &quot;{message}&quot;
      </StyledErrorMessageText>
    );
  }, [message]);

  return (
    <div className={wrapperStyles}>
      <StyledHeaderText variant={MDSTextVariant.TextS} weight={MDSTextWeight.Bold}>
        Something went wrong!
      </StyledHeaderText>
      {messageContent}
      <MDSButton onClick={forceRefreshPage}>Refresh Page</MDSButton>
    </div>
  );
});
